import { useMemo } from "react";
import PiCreatorDropdownItem from "../../../components/PiCreatorDropdown/PiCreatorDropdownItem";
import { PiInteractionDropdown } from "../../../components/PiInteractionDropdown";
import usePropHelper from "../../../hooks/PropHelper";
import PiCreatorDropdown from "../../../components/PiCreatorDropdown/PiCreatorDropdown";

export default function NodeAttachTagDropdown(props: {
  onChange: (tag: string) => void;
  selectedTag: string;
  selectedProp: string;
}) {
  const { selectedProp, selectedTag, onChange } = { ...props };
  const { tryGetUsedPropByInstanceId } = usePropHelper();

  const myProp = selectedProp
    ? tryGetUsedPropByInstanceId(selectedProp)
    : undefined;

  const getDropdownItems = () => {
    if (!selectedProp || !myProp) return [] as JSX.Element[];

    return myProp?.metadata.attachmentTags.map((tag) => {
      return (
        <PiCreatorDropdownItem
          text={tag.tag}
          icon={<></>}
          onClick={() => onChange(tag.tag)}
        />
      );
    });
  };

  const trigger = useMemo(() => {
    return (
      <div
        className={
          "flex items-center w-full h-full font-normal gap-[10px] px-[8px] text-creator-text text-[13px]"
        }
      >
        <div className={"my-auto truncate"}>{selectedTag}</div>
      </div>
    );
  }, [selectedTag]);

  const dropdown = (
    <PiCreatorDropdown
      style="square"
      label={"Tag"}
      trigger={trigger}
      items={getDropdownItems()}
    />
  );
  return <>{dropdown}</>;
}
